import { render, staticRenderFns } from "./UserCurrent.vue?vue&type=template&id=3d96bcbf&scoped=true&"
import script from "./UserCurrent.vue?vue&type=script&lang=js&"
export * from "./UserCurrent.vue?vue&type=script&lang=js&"
import style0 from "./UserCurrent.vue?vue&type=style&index=0&id=3d96bcbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d96bcbf",
  null
  
)

export default component.exports